import React from 'react';
export const ContextAffiliate = React.createContext();
